export default {
  identityPoolId: "ap-northeast-1:6384351e-d92f-4369-af2f-0280957df664",
  graphqlEndpoint: "https://graphql.portal.company.works-hi.com/graphql",
  apiGatewayCustomDomainName: "https://portal.company.works-hi.com",
  aws_project_region: "ap-northeast-1",
};
